var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDisponivelWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8DCBC668-F90C-494D-A915-271349B220D4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05.1-nova-assinatura",
    transform: "translate(-440.000000, -622.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-disponivel",
    transform: "translate(440.000000, 622.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#6EB34F",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(4.000000, 6.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2928932,-0.707106781 C15.6834175,-1.09763107 16.3165825,-1.09763107 16.7071068,-0.707106781 C17.0675907,-0.34662282 17.0953203,0.220608236 16.7902954,0.612899443 L16.7071068,0.707106781 L5.70710678,11.7071068 C5.34662282,12.0675907 4.77939176,12.0953203 4.38710056,11.7902954 L4.29289322,11.7071068 L-0.707106781,6.70710678 C-1.09763107,6.31658249 -1.09763107,5.68341751 -0.707106781,5.29289322 C-0.34662282,4.93240926 0.220608236,4.90467972 0.612899443,5.20970461 L0.707106781,5.29289322 L5,9.585 L15.2928932,-0.707106781 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDisponivelWhite);
export default __webpack_public_path__ + "static/media/ic-disponivel-white.bdf7b9e9a6c56f88e23cf0743ff5948c.svg";
export { ForwardRef as ReactComponent };